import type { MonsterTokenStyle } from '../api';
import { useMonsterTokenStyle } from './clientSettings';

export const DIGITAL_RIFT_ARTWORK = '/rifts/rework/small/Rift.webp';

export const getRiftArtworkPath = (style: MonsterTokenStyle, side: 'front' | 'back' = 'front') =>
  style === 'Digital' ? DIGITAL_RIFT_ARTWORK : `/rifts/Rift${side === 'front' ? 'Front' : 'Back'}.png`;

export const useRiftArtworkPath = (side: 'front' | 'back' = 'front') =>
  getRiftArtworkPath(useMonsterTokenStyle(), side);
